(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rcps-attribution"] && !Shopify.designMode) return;
  try {
    (() => {
  const forms = {
    '242685775090163': { start: 33, title: 'RCP-ALL-Yard Evaluation' },
    '242683885625167': { start: 33, title: 'RCP-PG1-PROMO' },
    '252584493634163': { start: 34, title: 'Facebook Ad-RCP-PG1-99 DOWN' },
    '241938797819176': { start: 30, title: 'RCP-ALL-PROMO' },
    '242743657006154': { start: 37, title: 'RCP-PG1-RTO' },
    '242685105103145': { start: 36, title: 'RCP-CP-Catalog' },
    '242685792012156': { start: 35, title: 'RCP-CP-Yard Evaluation' },
    '242684695619170': { start: 32, title: 'RCP-ALL-Catalog' },
    '242683754695169': { start: 33, title: 'RCP-BPK-PROMO' },
    '242684505723156': { start: 36, title: 'RCP-BPK-Catalog' },
    '242684390546161': { start: 36, title: 'RCP-PG1-Catalog' },
    '242685694915169': { start: 35, title: 'RCP-PFH-Yard Evaluation' },
    '241944169552160': { start: 32, title: 'RCP-PFH-PROMO' },
    '250134537197155': { start: 52, title: 'APPLY at River City Play Systems' },
    '242684950636163': { start: 36, title: 'RCP-BT-Catalog' },
    '242684396112156': { start: 33, title: 'RCP-BT-PROMO' },
    '242825112635149': { start: 35, title: 'Clone of RCP-ALL-PROMO' },
    '241945252147154': { start: 35, title: 'RCP-PFH-Catalog' },
    '252584615720155': { start: 34, title: 'Facebook Ad-RCP-PG1-500 FREE' },
    '252584084481159': { start: 34, title: 'Facebook Ad-RCP-PG1-SAVE 10' },
    '242685681860164': { start: 34, title: 'RCP-PG1-Yard Evaluation' },
    '252955893562169': { start: 35, title: 'Facebook Ad-RCP-PG1-Free Trampoline' },
    '253364428075157': { start: 33, title: 'RCP-SPECIAL EVENTS' },
    '242685444394163': { start: 35, title: 'RCP-BT-Yard Evaluation' },
    '250055503169149': { start: 39, title: 'Facebook Ad-RCP-PG1-RTO' }
  };

  const firstKey = 'rcps_attribution_first_v1';
  const latestKey = 'rcps_attribution_latest_v1';
  const lifetime = 90 * 24 * 60 * 60 * 1000;
  const query = new URLSearchParams(window.location.search);
  const clickSource = query.get('gclid') ? 'google' : query.get('fbclid') ? 'meta' : '';
  const clickMedium = query.get('gclid') ? 'cpc' : query.get('fbclid') ? 'paid_social' : '';

  let referrerHost = '';

  try {
    referrerHost = document.referrer ? new URL(document.referrer).hostname : '';
  } catch (error) {
    referrerHost = '';
  }

  const normalizedHost = (host) => String(host || '').toLowerCase().replace(/^www\./, '');
  const referrerDomain = normalizedHost(referrerHost);
  const sameStore = referrerDomain === normalizedHost(window.location.hostname) || referrerDomain === 'rivercityplay.com' || referrerDomain === 'river-city-play-systems.myshopify.com';
  const formReturn = ['jotform.com', 'jotformpro.com'].some((domain) => referrerDomain === domain || referrerDomain.endsWith('.' + domain));
  const externalReferrer = Boolean(referrerHost && !sameStore && !formReturn);

  const current = {
    source: query.get('utm_source') || clickSource || (externalReferrer ? referrerHost : 'direct'),
    medium: query.get('utm_medium') || clickMedium || (externalReferrer ? 'referral' : '(none)'),
    campaign: query.get('utm_campaign') || '',
    content: query.get('utm_content') || '',
    term: query.get('utm_term') || '',
    landing: window.location.href,
    referrer: document.referrer || '',
    gclid: query.get('gclid') || '',
    fbclid: query.get('fbclid') || '',
    captured_at: Date.now()
  };

  const paidOrReferred = Boolean(
    query.get('utm_source') ||
    query.get('utm_medium') ||
    query.get('utm_campaign') ||
    current.gclid ||
    current.fbclid ||
    externalReferrer
  );

  const readStored = (key) => {
    try {
      return JSON.parse(window.localStorage.getItem(key) || 'null');
    } catch (error) {
      return null;
    }
  };

  const writeStored = (key, value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return;
    }
  };

  let first = readStored(firstKey);

  if (!first || !first.captured_at || Date.now() - first.captured_at > lifetime) {
    first = current;
    writeStored(firstKey, first);
  }

  let latest = readStored(latestKey);

  if (!latest || paidOrReferred) {
    latest = current;
    writeStored(latestKey, latest);
  }

  const fieldNames = (start) => ({
    brand: 'attributionBrand',
    formName: 'attributionForm',
    formId: `attributionForm${start + 2}`,
    firstSource: 'firstTouch',
    firstMedium: `firstTouch${start + 4}`,
    firstCampaign: `firstTouch${start + 5}`,
    firstContent: `firstTouch${start + 6}`,
    firstTerm: `firstTouch${start + 7}`,
    firstLanding: `firstTouch${start + 8}`,
    firstReferrer: `firstTouch${start + 9}`,
    latestSource: 'latestTouch',
    latestMedium: `latestTouch${start + 11}`,
    latestCampaign: `latestTouch${start + 12}`,
    latestContent: `latestTouch${start + 13}`,
    latestTerm: `latestTouch${start + 14}`,
    latestLanding: `latestTouch${start + 15}`,
    latestReferrer: `latestTouch${start + 16}`,
    gclid: 'googleClick',
    fbclid: 'metaClick'
  });

  const formIdFromUrl = (value) => {
    const match = String(value || '').match(/(?:jsform\/|form\.jotform\.com\/)(\d{15})/);
    return match ? match[1] : '';
  };

  const decorateUrl = (value, formId) => {
    const config = forms[formId];

    if (!config) return value;

    const fields = fieldNames(config.start);
    const url = new URL(value, window.location.href);

    const values = {
      [fields.brand]: 'River City Play Systems',
      [fields.formName]: config.title,
      [fields.formId]: formId,
      [fields.firstSource]: first.source || '',
      [fields.firstMedium]: first.medium || '',
      [fields.firstCampaign]: first.campaign || '',
      [fields.firstContent]: first.content || '',
      [fields.firstTerm]: first.term || '',
      [fields.firstLanding]: first.landing || '',
      [fields.firstReferrer]: first.referrer || '',
      [fields.latestSource]: latest.source || '',
      [fields.latestMedium]: latest.medium || '',
      [fields.latestCampaign]: latest.campaign || '',
      [fields.latestContent]: latest.content || '',
      [fields.latestTerm]: latest.term || '',
      [fields.latestLanding]: latest.landing || '',
      [fields.latestReferrer]: latest.referrer || '',
      [fields.gclid]: latest.gclid || first.gclid || '',
      [fields.fbclid]: latest.fbclid || first.fbclid || ''
    };

    Object.entries(values).forEach(([key, fieldValue]) => {
      if (fieldValue) url.searchParams.set(key, fieldValue);
    });

    return url.toString();
  };

  const decorate = () => {
    document.querySelectorAll('iframe[src*="form.jotform.com/"]').forEach((frame) => {
      if (frame.dataset.rcpsAttribution === 'true') return;

      const formId = formIdFromUrl(frame.src);

      if (!forms[formId]) return;

      const decorated = decorateUrl(frame.src, formId);
      frame.dataset.rcpsAttribution = 'true';

      if (decorated !== frame.src) frame.src = decorated;
    });

    document.querySelectorAll('a[href*="form.jotform.com/"]').forEach((link) => {
      if (link.dataset.rcpsAttribution === 'true') return;

      const formId = formIdFromUrl(link.href);

      if (!forms[formId]) return;

      link.href = decorateUrl(link.href, formId);
      link.dataset.rcpsAttribution = 'true';
    });
  };

  decorate();

  new MutationObserver(decorate).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
  } catch(e) { console.error(e); }
})();

})();
